module.exports = require('@theia/application-package/lib/environment');
